import { render, staticRenderFns } from "./Kucun.vue?vue&type=template&id=0614cd51&scoped=true"
import script from "./Kucun.vue?vue&type=script&lang=js"
export * from "./Kucun.vue?vue&type=script&lang=js"
import style0 from "./Kucun.vue?vue&type=style&index=0&id=0614cd51&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614cd51",
  null
  
)

export default component.exports